module.exports = __webpack_public_path__ + "img/com-esg.a46ed3ee.png";